import { useEffect } from "react";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { tokenCheckMs } from "../constants";

const cookies = new Cookies();

// Stuurt terug naar het inlogscherm zodra het token weg is.
export function useSessionGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!cookies.get("token")) {
      navigate("/");
      return undefined;
    }
    const timer = setInterval(() => {
      if (!cookies.get("token")) navigate("/");
    }, tokenCheckMs);
    return () => clearInterval(timer);
  }, [navigate]);
}
